/**
 * Navigation guard to prevent redirect loops
 * Debounces navigation calls to prevent multiple redirects from firing
 */

let navigating = false;
let navigationTimeout: ReturnType<typeof setTimeout> | null = null;

/**
 * Safe navigation function that prevents redirect loops
 * @param fn Navigation function to execute
 */
export function safeNavigate(fn: () => void): void {
  if (navigating) {
    console.log("[safeNavigate] Navigation already in progress, skipping");
    return;
  }

  navigating = true;
  fn();

  // Reset the flag after a short delay
  if (navigationTimeout) {
    clearTimeout(navigationTimeout);
  }
  navigationTimeout = setTimeout(() => {
    navigating = false;
  }, 1000);
}

/**
 * Reset the navigation guard (useful for testing or manual intervention)
 */
export function resetNavigationGuard(): void {
  navigating = false;
  if (navigationTimeout) {
    clearTimeout(navigationTimeout);
    navigationTimeout = null;
  }
}
